/** Shared contract types for the client-contact directory pages. */

export interface ContactRecord {
  readonly id: string;
  readonly email: string;
  readonly name: string;
  readonly phone: string;
  readonly cell: string;
  readonly roles: readonly string[];
  readonly accounts: readonly string[];
  readonly eventCount: number;
  readonly lastEventAt: string | null;
}

export interface ContactEventRow {
  readonly id: string;
  readonly name: string;
  readonly contractNumber: string | null;
  readonly stageName: string | null;
  readonly eventDate: string | null;
  /** The event's real start instant and zone — see `@/lib/event-time`. */
  readonly timeStart?: string | null;
  readonly timeZone?: string | null;
  readonly longTimeZone?: string | null;
  readonly accountName: string | null;
  readonly accountId: string | null;
  readonly participants: number | null;
  readonly program: string | null;
}

/** Directory data changes nightly — no need to refetch per navigation. */
export const CONTACT_STALE_MS = 5 * 60_000;
